import ErrorBoundary from 'sharedComponents/ErrorBoundary';
import { lazy, Suspense } from 'react';
import { Spinner } from '@7shifts/sous-chef';

const SettingsPage = lazy(() => import('./pages/SettingsPage'));
const KanbanStagesPage = lazy(() => import('./pages/KanbanStagesPage'));
const ClosingReasonsPage = lazy(() => import('./pages/CloseReasonsPage'));

export const ROUTES = [
    {
        path: '/settings',
        element: (
            <Suspense fallback={<Spinner block />}>
                <SettingsPage />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />
    },
    {
        path: '/settings/kanban-stages',
        element: (
            <Suspense fallback={<Spinner block />}>
                <KanbanStagesPage />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />
    },
    {
        path: '/settings/closing-reasons',
        element: (
            <Suspense fallback={<Spinner block />}>
                <ClosingReasonsPage />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />
    }
];
